<template>
  <div>
    <div class="row justify-content-md-center" v-cloak v-if="!state.loaded">
      <div class="col col-lg-2"></div>
      <div class="col-md-auto mt-20">
        <rotate-square5></rotate-square5>
      </div>
      <div class="col col-lg-2"></div>
    </div>
    <div class="card" v-else>
      <div class="card-body">
        <form @submit.prevent="submit" class="form-horizontal" autocomplete="off">
          <div class="form-body">
            <h3 class="box-title">User Management</h3>
            <hr class="m-t-0 m-b-40" />
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.nip"
                  name="NIP"
                  required
                  type="text"
                  label="NIP"
                />
              </div>
                <div class="col-md-4">
                  <button
                    @click="showFindUser"
                    class="m-l-4 btn btn-success"
                    title="search"
                    type="button"
                  >
                    Search
                  </button>
                  <button
                    @click="resetPayload"
                    class="m-l-5 btn btn-warning"
                    title="reset"
                    type="button"
                  >
                    Reset
                  </button>
                </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.nik"
                  name="nik"
                  type="text"
                  label="NIK"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.gelarDepan"
                  name="gelarDepan"
                  type="text"
                  label="Gelar Depan"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.namaAsli"
                  @input="generateCodeInitials"
                  name="Nama Asli"
                  type="text"
                  label="Nama Asli"
                  :required="true"
                />
                  <!-- :readonly="payload.is_active_directory === 1 ? true : false" -->
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.gelarBelakang"
                  name="gelarBelakang"
                  type="text"
                  label="Gelar Belakang"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.username"
                  name="username"
                  required
                  type="text"
                  label="Nama Pengguna (Username)"
                  :readonly="payload.is_active_directory === 1 ? true : false"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.email"
                  name="Email"
                  :readonly="payload.is_active_directory === 1 ? true : false"
                  type="text"
                  label="Email"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div
                  :class="[
                    'form-group',
                    { 'has-danger': errors.has('password') },
                    ' row',
                  ]"
                >
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                  >
                    Password
                    <small style="color: red" v-if="!editMode">*</small>
                  </label>
                  <div class="col-md-9 col-xs-9">
                    <input
                      v-model="payload.password"
                      type="text" style="text-security:disc; -webkit-text-security:disc;"
                      v-validate="payload.is_active_directory != 1 && !editMode ? 'required|kemlu_password' : ''"
                      name="password"
                      ref="password"
                      :class="[
                        'form-control',
                        { 'form-control-danger': errors.has('password') },
                      ]"
                      :readonly="payload.is_active_directory === 1 ? true : false"
                    />
                    <small
                      v-if="errors.has('password')"
                      class="form-control-feedback"
                      >{{ errors.first("password") }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div
                  :class="[
                    'form-group',
                    { 'has-danger': errors.has('password_confirmation') },
                    ' row',
                  ]"
                >
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >
                    Confirm Password
                    <small style="color: red" v-if="!editMode">*</small>
                  </label>
                  <div class="col-md-9 col-xs-9">
                    <input
                      type="text" style="text-security:disc; -webkit-text-security:disc;"
                      v-validate="payload.is_active_directory != 1 && !editMode ? 'required|confirmed:password' : ''"
                      data-vv-as="password"
                      name="password_confirmation"
                      :class="[
                        'form-control',
                        {
                          'form-control-danger': errors.has(
                            'password_confirmation'
                          ),
                        },
                      ]"
                      :readonly="payload.is_active_directory === 1 ? true : false"
                    />
                    <small
                      v-if="errors.has('password_confirmation')"
                      class="form-control-feedback"
                      >Password confirmation does not match</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr class="m-t-0 m-b-40" />

            <template v-for="(role, index) in payload.multirole">
              <div class="row" :key="index">
                <div class="col-md-8">
                  <div class="form-group row">
                    <label
                      :class="[
                        'control-label',
                        { 'text-right': !isMobile },
                        'col-md-3',
                      ]"
                    >
                      Unit
                      <small style="color: red">*</small>
                    </label>
                    <div :class="['col-md-9', { invalid: !role.unitValue }]">
                      <treeselect
                        :multiple="false"
                        :options="optionUnit"
                        :flat="true"
                        :sort-value-by="'INDEX'"
                        :default-expand-level="1"
                        :flatten-search-results="true"
                        placeholder="Unit"
                        v-model="role.unitValue"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :key="index + '1'">
                <div class="col-md-8">
                  <div class="form-group row">
                    <label
                      :class="[
                        'control-label',
                        { 'text-right': !isMobile },
                        'col-md-3',
                      ]"
                    >
                      Jabatan
                      <small style="color: red">*</small>
                    </label>
                    <div :class="['col-md-9', { invalid: !role.jabatanValue }]">
                      <Multiselect
                        placeholder="Type to search"
                        select-label="Enter doesn’t work here!"
                        :value="role.jabatanValue"
                        track-by="value"
                        label="text"
                        :options="optionJabatan"
                        :searchable="true"
                        :allow-empty="false"
                        :hide-selected="false"
                        :max-height="150"
                        :disabled="isDisabled"
                        :block-keys="['Tab', 'Enter']"
                        @input="onChangeJabatanNew(role, $event)"
                        @close="onTouch"
                        @open="jabatanFind(role.unitValue, '')"
                        @search-change="jabatanFind(role.unitValue, $event)"
                      ></Multiselect>
                      <label
                        class="typo__label form__label"
                        v-show="!role.jabatanValue"
                        >Must have at least one value</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" :key="index + '2'">
                <div class="col-md-8">
                  <div class="form-group row">
                    <label
                      :class="[
                        'control-label',
                        { 'text-right': !isMobile },
                        'col-md-3',
                      ]"
                    >
                      Role
                      <small style="color: red">*</small>
                    </label>
                    <div
                      :class="[
                        'col-md-9',
                        { invalid: !role.groupValue.length },
                      ]"
                    >
                      <Multiselect
                        v-model="role.groupValue"
                        label="text"
                        track-by="value"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="listGroup"
                        :multiple="true"
                        :searchable="true"
                        :loading="isLoadingRole"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="false"
                        :options-limit="300"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="false"
                        @open="groupFind('')"
                        @search-change="groupFind"
                      >
                        <span slot="noResult">Oops! No Group found.</span>
                      </Multiselect>
                      <label
                        class="typo__label form__label"
                        v-show="!role.groupValue.length"
                        >Must have at least one value</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :key="index + '5'">
                <div class="col-md-8">
                  <Input
                    v-model="role.place"
                    name="tempat"
                    type="text"
                    label="Tempat"
                  />
                </div>
              </div>
              <button
                :key="index + '7'"
                v-if="payload.multirole.length !== 1"
                @click.prevent="deleteUnitMultiple(index)"
                class="m-l-4 btn btn-danger"
                title="Hapus Unit"
              >
                Hapus Unit</button
              >&nbsp;
              <button
                :key="index + '6'"
                v-if="payload.multirole.length - 1 === index"
                @click.prevent="addUnitMultiple"
                class="m-l-4 btn btn-success"
                title="Tambah Unit"
              >
                Tambah Unit</button
              >&nbsp;
              <hr :key="index + '4'" />
            </template>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Jenis Kelamin</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.gender"
                          type="radio"
                          value="1"
                          class="form-check-input"
                          name="gender"
                        />Laki-laki
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.gender"
                          type="radio"
                          value="0"
                          class="form-check-input"
                          name="gender"
                        />Perempuan
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.date_birth"
                  name="date_birth"
                  type="date"
                  label="Tanggal Lahir"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.place_birth"
                  name="place_birth"
                  type="text"
                  label="Tempat Lahir"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                  >
                    Provinsi
                    <!-- <small style="color: red">*</small> -->
                  </label>
                  <div :class="['col-md-9']">
                    <Multiselect
                      placeholder="Type to search"
                      select-label="Enter doesn’t work here!"
                      :value="payload.province"
                      track-by="value"
                      label="text"
                      :options="optionProvince"
                      :searchable="true"
                      :allow-empty="true"
                      :hide-selected="false"
                      :max-height="150"
                      :block-keys="['Tab', 'Enter']"
                      @input="onChangeProvince"
                      @close="onTouch"
                    ></Multiselect>
                    <!-- <label
                      class="typo__label form__label"
                      v-show="!payload.province"
                      >Must have at least one value</label
                    > -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                  >
                    Kota/Kabupaten
                    <!-- <small style="color: red">*</small> -->
                  </label>
                  <div :class="['col-md-9']">
                    <Multiselect
                      placeholder="Type to search"
                      select-label="Enter doesn’t work here!"
                      :value="payload.district"
                      track-by="value"
                      label="text"
                      :options="optionDistrict"
                      :searchable="true"
                      :allow-empty="true"
                      :hide-selected="false"
                      :max-height="150"
                      :disabled="isDisabledDistrict"
                      :block-keys="['Tab', 'Enter']"
                      @input="onChangeDistrict"
                      @close="onTouch"
                    ></Multiselect>
                    <!-- <label
                      class="typo__label form__label"
                      v-show="!payload.district"
                      >Must have at least one value</label 
                    >-->
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                  >
                    Kecamatan
                    <!-- <small style="color: red">*</small> -->
                  </label>
                  <div
                    :class="['col-md-9']"
                  >
                    <Multiselect
                      placeholder="Type to search"
                      select-label="Enter doesn’t work here!"
                      :value="payload.sub_district"
                      track-by="value"
                      label="text"
                      :options="optionSubdistrict"
                      :searchable="true"
                      :allow-empty="true"
                      :hide-selected="false"
                      :max-height="150"
                      :disabled="isDisabledSubdistrict"
                      :block-keys="['Tab', 'Enter']"
                      @input="onChangeSubdistrict"
                      @close="onTouch"
                    ></Multiselect>
                    <!-- <label
                      class="typo__label form__label"
                      v-show="!payload.sub_district"
                      >Must have at least one value</label
                    > -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.zip_code"
                  name="zip_code"
                  type="text"
                  label="Kode Pos"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >E-KTP</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <Upload
                      v-model="payload.ktp_photo"
                      :value="payload.ktp_photo"
                      isImage
                      name="ktp_photo"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Foto Selfie</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <Upload
                      v-model="payload.selfie_photo"
                      :value="payload.selfie_photo"
                      isImage
                      name="selfie_photo"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <!-- <Input
                  v-model="code_initials"
                  type="text"
                  label="Kode Marker"
                  maxlength="4"
                  name="kode_marker"
                  v-if="payload.code_initials == ''"
                />  -->

                <Input
                  v-model="payload.code_initials"
                  type="text"
                  label="Kode Marker"
                  name="kode_marker"
                  maxlength="5"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Penanda Tangan</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.is_signer"
                          type="radio"
                          value="1"
                          class="form-check-input"
                          name="is_signer"
                        />Ya
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.is_signer"
                          type="radio"
                          value="0"
                          class="form-check-input"
                          name="is_signer"
                        />Tidak
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-8">
                <Input
                  v-model="payload.noTlp"
                  name="sifat surat"
                  type="text"
                  label="No Telpon"
                  :readonly="payload.is_active_directory === 1 ? true : false"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Alamat</label
                  >
                  <div class="col-md-9 col-xs-9">
                    <textarea
                      v-model="payload.address"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Deskripsi</label
                  >
                  <div class="col-md-9 col-xs-9">
                    <textarea
                      v-model="payload.desc"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <hr class="m-t-0 m-b-40" />
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Aktif</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.isActive"
                          type="radio"
                          value="1"
                          class="form-check-input"
                          name="optradio"
                        />Ya
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          v-model="payload.isActive"
                          type="radio"
                          value="0"
                          class="form-check-input"
                          name="optradio"
                        />Tidak
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group row">
                  <label
                    :class="[
                      'control-label',
                      { 'text-right': !isMobile },
                      'col-md-3',
                    ]"
                    >Upload Gambar</label
                  >
                  <div class="col-md-9 col-sm-9">
                    <Upload
                      v-model="payload.photos"
                      :value="payload.photos"
                      isImage
                      name="photo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style="display:none;">
              <drop-file @data="assignFilep12"></drop-file>
            </div>
          </div>
          <hr />
          <div class="form-actions">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-offset-3 col-md-9">
                    <button
                      type="submit"
                      class="btn btn-success"
                      title="Simpan"
                    >
                      Submit</button
                    >&nbsp;
                    <button
                      type="button"
                      @click="goBack()"
                      class="btn btn-inverse"
                      title="Cancel"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { RotateSquare5 } from "vue-loading-spinner";
import Input from "@/components/input/input";
import Multiselect from "vue-multiselect";
import Upload from "@/components/input/upload.vue";
import axios from "axios";

export default {
  components: {
    Input,
    RotateSquare5,
    Upload,
    Multiselect,
  },
  computed: {
    // code_initials(){
    //   console.log(this.payload.namaAsli.match(/(\b\S)?/g).join("").toUpperCase());
    //   // if(this.payload.code_initials==""){
    //     return this.payload.namaAsli.match(/(\b\S)?/g).join("").toUpperCase();
    //   // } else {
    //   //   return this.payload.code_initials;
    //   // }
    // },
    editMode() {
      return !!this.$route.params.id;
    },
    state() {
      return this.$store.state.user;
    },
    isInvalidJabatan() {
      return this.isTouched && this.payload.valueJabatan.length === 0;
    },
    isInvalidProvince() {
      return this.isTouched && this.payload.province.length === 0;
    },
    isInvalidDistrict() {
      return this.isTouched && this.payload.district.length === 0;
    },
    isInvalidSubdistrict() {
      return this.isTouched && this.payload.sub_district.length === 0;
    },
    isInvalidBahasa() {
      return this.isTouched && this.payload.valueBahasa.length === 0;
    },
    isInvalidUnit() {
      return this.isTouched && this.payload.valueUnit.length === 0;
    },
    isInvalidGroup() {
      return this.isTouched && this.payload.group.length === 0;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  data() {
    return {
      optionBahasa: [
        { id: "id", text: "Indonesia" },
        { id: "en", text: "English" },
      ],
      payload: {
        is_active_directory: 0,
        nik: "",
        gelarDepan: "",
        namaAsli: "",
        gelarBelakang: "",
        username: "-",
        email: "",
        password: "",
        jabatan: "",
        valueJabatan: [],
        noTlp: "",
        address: "",
        desc: "",
        multirole: [],
        valueBahasa: [],
        valueUnit: [],
        group: [],
        p12: "",
        superAdmin: false,
        cuti: "0",
        isActive: "1",
        photos: "",
        gender: "",
        date_birth: "",
        place_birth: "",
        province: [],
        district: [],
        sub_district: [],
        zip_code: "",
        ktp_photo: "",
        selfie_photo: "",
        code_initials: "",
        is_signer: "",
      },
      userGroup: [],
      optionJabatan: [],
      optionProvince: [],
      optionDistrict: [],
      optionSubdistrict: [],
      optionUnit: [],
      myPhoto: [],
      myKtpPhoto: [],
      mySelfiePhoto: [],
      isTouched: false,
      isLoading: false,
      isLoadingRole: false,
      listGroup: [],
      listPosition: [],
      listEselon: [],
      isDisabled: false,
      isDisabledDistrict: true,
      isDisabledSubdistrict: true,
    };
  },
  mounted() {
    this.payload.username = ''
    this.unitFind();
    this.provinceFind();
    this.initialize();
  },

  methods: {
    resetPayload() {
      this.payload = {
        is_active_directory: 0,
        nik: "",
        gelarDepan: "",
        namaAsli: "",
        gelarBelakang: "",
        username: "-",
        email: "",
        password: "",
        jabatan: "",
        valueJabatan: [],
        noTlp: "",
        address: "",
        desc: "",
        multirole: [],
        valueBahasa: [],
        valueUnit: [],
        group: [],
        p12: "",
        superAdmin: false,
        cuti: "0",
        isActive: "1",
        photos: "",
        gender: "",
        date_birth: "",
        place_birth: "",
        province: [],
        district: [],
        sub_district: [],
        zip_code: "",
        ktp_photo: "",
        selfie_photo: "",
        code_initials: "",
        is_signer: "",
      }
    },
    updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 4) {
        this.payload.code_initials = value
      }
      this.$forceUpdate()
    },
    assignFilep12(p12) {
      this.payload.p12 = p12;
    },
    generateCodeInitials() {
      // if(this.payload.namaAsli==""){
        // console.log(this.payload.namaAsli.match(/(\b\S)?/g).join("").toUpperCase());
      // this.payload.code_initials = this.payload.namaAsli.match(/(\b\S)?/g).join("").toUpperCase();
      // }
      this.payload.code_initials = this.getInitials(this.payload.namaAsli);//split(" ").map((n,i,a)=> i === 0 || i+1 === a.length ? n[0] : null).join("");
    },
    getInitials(string) {
      // console.log('run getInitials');
        // remove numerics
        string = string.replace(/\d+/g, '')
        // remove multiple spaces
        string = string.replace(/\s\s+/g, ' ')
        var names = string.split(' '), initials = '', maxLength = 5, loopLimit = 0;
        // maximum initials length
        loopLimit = names.length > 5 ? 5 : names.length

        if (names.length > 0) {
          for (let i = 0; i < loopLimit; i++){
            if (i < maxLength) {
              initials += names[i].substring(0, 1).toUpperCase();
            }
          }
        }
        // return with remove all non character
        return initials.replace(/[^\w ]/g, '');
    },

    deleteUnitMultiple(index) {
      this.payload.multirole.splice(index, 1);
    },
    addUnitMultiple() {
      this.payload.multirole.push({
        unitValue: null,
        jabatanValue: null,
        groupValue: [],
        place: null,
        province: null,
        district: null,
        sub_district: null,
      });
    },
    async initialize() {
      try {
        if (this.editMode) {
          const {
            data: { data },
          } = await axios.get(`/users/${this.$route.params.id}`);
          const state = {
            loaded: true,
          };

          this.$store.commit("user/STATE", state);
          // if(this.optionProvince.length != 0){
          //     this.optionProvince.find(
          //       (item) => item.value == data.province
          //     )
          // }
 
          this.districtFind(data.province);
          this.subdistrictFind(data.province, data.district);
          setTimeout(()=> {
            this.edit(data);
          }, 2000)
        } else {
          this.$store.dispatch("user/onAdd");
          this.addUnitMultiple();
        }
      } catch (e) {
        this.handleApiError(e);
        this.error = e.message;
      }
    },
    edit(data) {
      let user_group = [];
      if (Array.isArray(data.roles) && data.roles.length) {
        data.roles.forEach((value) => {
          user_group.push({ value: value.id, text: value.name });
        });
      }
      if(data.multipleUnits .length > 0) {
          data.multipleUnits = data.multipleUnits.map((element) => {
            element = Object.assign(element, {
              unitValue: element.unit.id,
            });
            if (element.structural) {
              element = Object.assign(element, {
                jabatanValue: {
                  value: element.structural ? element.structural.id : "",
                  text: element.structural ? element.structural.name : "",
                },
              });
            } else {
              element = Object.assign(element, {
                jabatanValue: null,
              });
            }
            element = Object.assign(element, {
              groupValue: element.roles.map((el) => {
                return {
                  text: el.name,
                  value: el.id,
                };
              }),
            });
            return element;
          });
      }
      this.isDisabledDistrict = false;
      this.isDisabledSubdistrict = false;

      this.payload = {
        is_active_directory: 0,
        gelarDepan: data.front_title,
        gelarBelakang: data.rear_title,
        namaAsli: data.name,
        username: data.username,
        email: data.email,
        password: "",
        nip: data.nip,
        nik: data.nik,
        jabatan: data.position,
        valueJabatan: data.position,
        eselon: data.structural_position_id
          ? data.structural_position_id.toString()
          : "",
        noTlp: data.phone,
        address: data.address,
        multirole: data.multipleUnits,
        desc: data.description,
        valueBahasa: {
          id: data.lang,
          text: data.lang === "id" ? "Indonesia" : "English",
        },
        valueUnit: data.units.map((element) => {
          return {
            text: element.name,
            value: element.id,
          };
        }),
        group: user_group,
        superAdmin: data.name,
        cuti: data.is_leave.toString(),
        isActive: data.is_active.toString(),
        photos: data.avatar,
        gender: data.gender,
        date_birth: data.date_birth,
        place_birth: data.place_birth,
        province: this.optionProvince.length != 0 && data.province != null ? this.optionProvince.find(
          (item) => item.value == data.province
        ) : [],
        district: this.optionDistrict.length != 0 && data.district != null ? this.optionDistrict.find(
          (item) => item.value == data.district
        ) : [],
        sub_district: this.optionSubdistrict.length != 0 && data.sub_district != null ? this.optionSubdistrict.find(
          (item) => item.value == data.sub_district
        ) : [],
        zip_code: data.zip_code,
        ktp_photo: data.ktp_avatar,
        selfie_photo: data.selfie_avatar,
        code_initials: data.code_initials,
        is_signer: data.is_signer,
      };
      this.optionProvince.value = data.province;
      this.optionDistrict.value = data.district;
      this.optionSubdistrict.value = data.sub_district;
      
      // this.showFindUser()
    },
    onTouch() {
      this.isTouched = true;
    },
    onChangeJabatan(value) {
      this.payload.valueJabatan = value;
    },
    onChangeJabatanNew(role, value) {
      role.jabatanValue = value;
    },
    onChangeProvince(value) {
      this.payload.province = value;
      this.isDisabledDistrict = false;
      this.payload.district = "";
      this.payload.sub_district = "";
      this.districtFind(this.payload.province.value);
    },
    onChangeDistrict(value) {
      this.payload.district = value;
      this.isDisabledSubdistrict = false;
      this.payload.sub_district = "";
      this.subdistrictFind(
        this.payload.province.value,
        this.payload.district.value
      );
    },
    onChangeSubdistrict(value) {
      this.payload.sub_district = value;
    },
    onChangeBahasa(value) {
      this.payload.valueBahasa = value;
    },
    onChangeUnit(value) {
      this.payload.valueUnit = value;
    },
    onChangeUnitNew(role, value) {
      role.unitValue = value;
    },
    goBack() {
      this.$store.dispatch("user/onCancel");
    },

    showFindUser() {
      this.payload.is_active_directory = 0
      let data = {
        nip : this.payload.nip 
      };
      axios.post(`users/findUserAD`, data).then((res) => {
        if (res.data.status != 'failed') {
          this.payload.is_active_directory = 1;
          var modifiedFullname = res.data.data.fullname.replace(/[\d\W_]+/g, ' '); // remove numbers, characters, and spaces after a period
          this.payload.namaAsli = modifiedFullname;
          this.payload.namaAsli = modifiedFullname;
          this.payload.email = res.data.data.email;
          this.payload.noTlp = res.data.data.telephone;
          this.payload.nip = res.data.data.nip;
          if (res.data.data.username != undefined) {
            this.payload.username = res.data.data.username;
          }
          this.payload.code_initials = this.getInitials(this.payload.namaAsli)
        }
      }).catch((err) => {
        // console.log(err)
      });
    },

    jabatanFind(unit, query) {
      this.isLoading = true;
      axios
        // .get(`positions/listByUnit?s=${query}&unit=${unit}`)
        .get(`positions/list?s=${query}`)
        .then((res) => {
          this.optionJabatan = res.data.items;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$store.commit("auth/LOGOUT");
          }
        });
    },
    async provinceFind() {
      this.isLoading = true;
      await axios.get('province')
      .then((response) => {
        const { status, data } = response.data
        if (data) {
          const province = Object.keys(data).map(function(key) { return {value: key, text: data[key]}; });
          this.optionProvince = province
        }
        this.isLoading = false
      }).catch((err) => {
        // console.log(err)
      })
    },
    districtFind(id_province) {
      this.isLoading = true;
      axios.get(`province/${id_province}/district`)
      .then((response) => {
        const { status, data } = response.data
        if (data) {
          const district = Object.keys(data).map(function(key) { return {value: key, text: data[key]}; });
          this.optionDistrict = district
        }
        this.isLoading = false
      }).catch((err) => {
        // console.log(err)
      })
    },
    subdistrictFind(id_province, id_district) {
      this.isLoading = true;
      axios.get(`province/${id_province}/district/${id_district}/subdistrict`)
      .then((response) => {
        const { status, data } = response.data
        if (data) {
          const subdistrict = Object.keys(data).map(function(key) { return {value: key, text: data[key]}; });
          this.optionSubdistrict = subdistrict
        }
        this.isLoading = false
      }).catch((err) => {
        // console.log(err)
      })
    },
    async unitFind() {
      this.isLoading = true;
      try {
        const response = await axios.get(`/unit-group/get-list-unit-user`)
        const { status, data } = response.data
        if (status === 'success') {
          this.optionUnit = data
        }
      } catch (err) {
        if (err.response.status === 401) {
          this.$store.commit("auth/LOGOUT");
        }
      }
    },
    groupFind(query) {
      this.isLoadingRole = true;
      axios
        .get(`groups/list?s=${query}`)
        .then((res) => {
          this.listGroup = res.data.items;
          this.isLoadingRole = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$store.commit("auth/LOGOUT");
          }
        });
    },
    eselonFind(query) {
      this.isLoading = true;
      axios
        .get(`eselons/list?s=${query}`)
        .then((res) => {
          this.listEselon = res.data.items;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$store.commit("auth/LOGOUT");
          }
        });
    },
    submit() {
      if (this.payload.photos) {
        this.myPhoto = this.payload.photos.split(",");
      }

      if (this.payload.ktp_photo) {
        this.myKtpPhoto = this.payload.ktp_photo.split(",");
      }

      if (this.payload.selfie_photo) {
        this.mySelfiePhoto = this.payload.selfie_photo.split(",");
      }
      // console.log('payload =', JSON.stringify(this.payload))
      const payload = {
        is_active_directory: this.payload.is_active_directory,
        name: this.payload.namaAsli,
        front_title: this.payload.gelarDepan,
        rear_title: this.payload.gelarBelakang,
        username: this.payload.username,
        email: this.payload.email,
        password: this.payload.password,
        nip: this.payload.nip,
        nik: this.payload.nik,
        position_id: parseInt(this.payload.valueJabatan.value),
        eselon_id: parseInt(this.payload.eselon),
        phone: this.payload.noTlp,
        address: this.payload.address,
        description: this.payload.desc,
        is_active: parseInt(this.payload.isActive),
        lang: "id",
        unit_id: this.payload.valueUnit.map((val) => {
          return parseInt(val.value);
        }),
        multirole: this.payload.multirole,
        user_group_id: this.payload.group,
        is_super_user: this.payload.superAdmin ? 1 : 0,
        is_leave: 0,
        photo: this.myPhoto[1],
        gender: this.payload.gender,
        date_birth: this.payload.date_birth,
        place_birth: this.payload.place_birth,
        province: this.payload.province.value,
        district: this.payload.district.value,
        sub_district: this.payload.sub_district.value,
        zip_code: this.payload.zip_code,
        ktp_photo: this.myKtpPhoto[1],
        selfie_photo: this.mySelfiePhoto[1],
        code_initials: this.payload.code_initials,
        is_signer: this.payload.is_signer,
      };
      
      const data = JSON.stringify(payload);
      let newData = new FormData();
      newData.append("data", data);
      newData.append("p12", this.payload.p12);
      let that = this
      this.$validator.validateAll().then((success) => {
        // if (success && payload.multirole.length) {
        if (success) {
          if (this.editMode) {
            newData.append("_method", "PATCH");
            this.$store.dispatch("user/submitEdit", {
              data: newData,
              id: this.$route.params.id,
            });
          } else {
            this.$store.dispatch("user/submitAdd", newData);
          }
        } else {
          window.scrollTo(0, 0);
        }
      });
    },
    getLang(id) {
      return this.$store.state.groups.lang[id];
    },
    getUserGroup() {
      axios
        .get(`/groups`, {
          params: {
            search: "",
            page: 1,
            limit: 100,
            sortable: "asc",
          },
        })
        .then((response) => {
          response = response.data;
          this.userGroup = response.items;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags {
  border: 1px solid #ced4da !important;
}
.invalid .multiselect__tags {
  border-color: #f04124 !important;
  padding: 5px 40px 0 8px !important;
}
.invalid .typo__label {
  color: #f04124;
  font-size: 0.8125rem;
}
.multiselect {
  color: #54667a !important;
}
.multiselect__select {
  height: 41px !important;
}
.form-control:disabled,
.form-control[readonly] {
 background-color:#e4ecf4 !important;
 opacity:1
}
</style>
